<thera-dropdown
  [defaultSelection]="selectedFacility?.facilityid"
  [options]="facilityOptions"
  (optionSelected)="onOptionSelected($event)"
></thera-dropdown>
